'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const InfoIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="InfoIcon">
      <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_299_966)">
          <path
            d="M10 19.6667C15.0626 19.6667 19.1667 15.5626 19.1667 10.5C19.1667 5.43743 15.0626 1.33337 10 1.33337C4.93743 1.33337 0.833374 5.43743 0.833374 10.5C0.833374 15.5626 4.93743 19.6667 10 19.6667Z"
            stroke={sx?.color || '#3D517B'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.95097 14.5427V9.42638C9.95097 9.23246 9.87397 9.04663 9.73689 8.90954C9.5998 8.77244 9.41389 8.69543 9.22005 8.69543H8.48914"
            stroke={sx?.color || '#3D517B'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.58551 7.12288C9.38368 7.12288 9.22009 6.95926 9.22009 6.75743C9.22009 6.55559 9.38368 6.39197 9.58551 6.39197"
            stroke={sx?.color || '#3D517B'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.58557 7.12288C9.78741 7.12288 9.95107 6.95926 9.95107 6.75743C9.95107 6.55559 9.78741 6.39197 9.58557 6.39197"
            stroke={sx?.color || '#3D517B'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.48914 14.5427H11.5108"
            stroke={sx?.color || '#3D517B'}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    </SvgIcon>
  )
}

InfoIcon.propTypes = {
  sx: PropTypes.object
}
